import styled from 'styled-components';

export const Wrapper = styled.div`
.timer {
  margin: 10px auto;
  text-align: center;
  font-size: 2.5rem;
  color: var(--fontMutedColor);
  font-weight: 500;

  &.urgent {
    color: var(--errorColor);
    font-weight: 600;
  }

  &.finished {
    font-size: 1.6rem;
    color: var(--fontMutedColor);
    font-weight: 400;
  }
}
`;